import { Tab, TabOverrides, Tabs } from 'baseui/tabs-motion';
import { Job } from '../../types/jobs';
import { JobResume } from './JobResume';
import { useState, Key } from 'react';
import { useStyles } from '../../hooks/useStyles';
import { JobActivitiesResume } from './activities/JobActivitiesResume';
import { JobHistory } from './JobHistory';

type Props = {
  job: Job;
};
export function JobDetailTabs({ job }: Readonly<Props>) {
  const [activeTab, setActiveTab] = useState<Key>('generalData');
  const { theme } = useStyles();

  const tabOverrides: TabOverrides = {
    TabPanel: {
      style: {
        overflowY: 'auto',
        flex: 1,
        padding: '0',
        maxHeight: '75vh'
      },
    },
  }

  
  return (
    <Tabs
      activeKey={activeTab}
      onChange={({ activeKey }) => setActiveTab(activeKey)}
      orientation="vertical"
      overrides={{
        Root: {
          style: {
            flex: '1',
            overflow: 'hidden',
          },
        },
        TabList: {
          style: {
            maxWidth: '100px',
            [theme.mediaQuery.medium]: {
              maxWidth: '200px',
            },
          },
        },
      }}
    >
      <Tab
        title={'Datos generales'}
        key={'generalData'}
        overrides={tabOverrides}
      >
        <JobResume
          job={job}
        />
      </Tab>
      <Tab
        title={'Actividades'}
        key={'activities'}
        overrides={tabOverrides}
      >
        <JobActivitiesResume activities={job.activities} jobId={job._id}/>
      </Tab>
      <Tab
        title={'Historial'}
        key={'history'}
        overrides={tabOverrides}
      >
        <JobHistory job={job} />
      </Tab>
    </Tabs>
  );
}
